import * as React from "react"
import { useTranslation } from "react-i18next"
import { cn } from "src/shadcn/lib/utils"
import { Loader2Icon } from "lucide-react"

function Spinner({ className, ...props }: React.ComponentProps<"svg">) {
  const { t } = useTranslation()

  return (
    <Loader2Icon role="status" aria-label={t("neetoatoms.spinner.loading", "Loading")} className={cn("size-4 animate-spin", className)} {...props} />
  )
}

export { Spinner }
